<template>
  <div>
    <yjheader title="自选合约"></yjheader>
    <tradeList :contentData="vmSelected"></tradeList>
  </div>
</template>

<script>
import * as _ from "lodash";
import yjheader from "@/components/common/yjheader";
import tradeList from "@/components/common/tradeList";
import art from "../../../static/js/proto/art/Art.js";
import front from "../../../static/js/proto/CtpFront.js";

// ---------------------------------------------------------------------------
export default {
  name: "selected",
  components: {
    yjheader,
    tradeList
  },

  ////////////////////////////////////////////////////////////////////////////
  data() {
    return {
      vmSelected: []
    };
  },

  ////////////////////////////////////////////////////////////////////////////
  mounted() {},
  activated() {
    footerIndex = 0;
    front.autoMount(art.bind(this, this.subscribe));
  },
  deactivated() {
    this.unsubscribe();
    beferFooterIndex = 0;
  },

  ////////////////////////////////////////////////////////////////////////////
  computed: {
    targetSelected() {
      return this.$store.state.targetSelected;
    },
    name() {
      return this.$options.name;
    }
  },
  watch: {
    vmSelected(news, old) {
      this.$store.commit('upDataSelect', this.vmSelected);
    }
  },

  ////////////////////////////////////////////////////////////////////////////
  methods: {
    // 订阅自选列表
    subscribe(reject) {
      // 1.已经订阅自选列表，则只需要订阅自选行情。
      var subTick = targetId =>
        front.subTick(targetId, {
          suberId: this.name,
          publish: tick => this.onTick(tick)
        });
      if (!art.empty(this.targetSelected)) {
        for (var targetId in this.targetSelected) {
          subTick(targetId);
        }
        return;
      }

      // 2.未订阅自选列表：订阅自选列表，再订阅行情。
      // 只添加自选列表：自选合约不存在更新。
      var addTarget = targetId => {
        if (!art.find(this.vmSelected, targetId, "targetId")) {
          const target = front.targetSet[targetId];
          if (target) {
            this.vmSelected.push({
              volume: 0,
              latestPrice: 0,
              lastSettlementPrice: 0,
              targetId: targetId,
              targetName: target.targetName
            });
          }
        } // endif
      };

      // 接收推送信息
      var publish = target => {
        if (!target.targetId) {
          return;
        }
        // 删除自选
        if (target.stamp == art.meta.stamp_remove) {
          front.unsubTick(target.targetId, this.name);
          art.erase(this.vmSelected, target.targetId, "targetId");
          return;
        }
        // 添加自选
        addTarget(target.targetId);
        subTick(target.targetId);
      };

      // 订阅自选列表
      art.clear(this.vmSelected);
      var sub = front.selectedTargetSub({
        suberId: this.name,
        publish,
        reject
      });
      this.$store.commit("selectLoad", sub);
      // console.log(this.vmSelected)
    },

    //////////////////////////////////////////////////////////////////////////
    // 取消订阅自选列表
    unsubscribe() {
      if (this.targetSelected) {
        for (var targetId in this.targetSelected) {
          front.unsubTick(targetId, this.name);
        }
      }
    },

    //////////////////////////////////////////////////////////////////////////
    // 合约行情信息
    onTick(tick) {
      // 只更新行情列表：添加由subscribe负责。
      var vm = art.find(this.vmSelected, tick.targetId, "targetId");
      if (vm) {
        var data = this.vmSelected[vm.index];
        data.volume = tick.volume;
        data.latestPrice = tick.latestPrice;
        data.lastSettlementPrice = tick.lastSettlementPrice;
        return;
      }
      console.error("warn" + tick.targetId);
    }

    //////////////////////////////////////////////////////////////////////////
  },// VUE.METHODS
}; // VUE.
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/yj/targetSelected.vue